import { Controller, ControllerProps } from 'react-hook-form';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import { Input, InputProps } from '@chakra-ui/react';
import {
  convertDateIntoDateString,
  DATE_FORMAT,
  parseDateString,
} from 'utils/dateUtils';

export type DatePickerProps<TFieldValues> = {
  controllerProps: Omit<ControllerProps<TFieldValues>, 'render'>;
  datePickerProps?: Partial<ReactDatePickerProps>;
  inputProps?: InputProps;
  /** バリューを string として扱うか */
  asString?: boolean;
};

const getSelectedDate = (value: unknown) => {
  if (typeof value === 'string')
    return value ? parseDateString(value) : undefined;

  return value as Date | null | undefined;
};

const handleChange =
  (onChange: (...event: unknown[]) => void, asString: boolean) =>
  (date: Date | null) => {
    if (asString) {
      const dateStr = date ? convertDateIntoDateString(date) : '';
      onChange(dateStr);
    } else {
      onChange(date);
    }
  };

export const DatePicker = <TFieldValues,>({
  controllerProps,
  datePickerProps,
  inputProps,
  asString = false,
}: DatePickerProps<TFieldValues>) => (
  <Controller
    {...controllerProps}
    render={({ field: { onChange, onBlur, value } }) => (
      <ReactDatePicker
        customInput={<Input {...inputProps} />}
        onChange={handleChange(onChange, asString)}
        onBlur={onBlur}
        selected={getSelectedDate(value)}
        dateFormat={DATE_FORMAT.DATE}
        showPopperArrow={false}
        popperProps={{
          strategy: 'fixed',
        }}
        {...datePickerProps}
      />
    )}
  />
);
